import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { SessionService } from '../session.service';

declare var $: any;

@Component({
  selector: 'app-my-resources',
  templateUrl: './my-resources.component.html',
  styleUrls: ['./my-resources.component.css']
})
export class MyResourcesComponent implements OnInit {

  isLoader: boolean = false;
  private apiUrl = 'https://api-url/endpoint';

  constructor(private myprofileRouter: Router, private http: HttpClient, private sessionService: SessionService) { }

  ngOnInit(): void {
  }

  showLogoutModel() {
    $('#LogoutModal').modal('toggle');
  }
  doLogout() {
    // Clear session storage on logout
    this.sessionService.submitSessionData();

    
    localStorage.removeItem('authData');
    localStorage.removeItem('authProfileData');
    localStorage.clear();
    localStorage.clear();
    $('.modal').modal('hide');
    setTimeout(() => {
      this.myprofileRouter.navigateByUrl('/m');
    }, 500);
  }



}
